











import Vue from "vue";
import PlotEdit from "@/components/organisms/PlotEdit.vue";
import PlotEditSp from "@/components/organisms/PlotEditSP.vue";
import { Plot, SubPlot } from "@/lib/models/plot";
import isMobile from "ismobilejs";
import clone from "lodash/cloneDeep";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: { PlotEdit, PlotEditSp },
  props: {
    novelId: String,
    plotId: String,
  },
  computed: {
    plot() {
      const { $store, plotId } = this;

      if (plotId) {
        return clone($store.getters["plotModule/subPlot"](plotId));
      } else {
        return clone($store.getters["plotModule/plots"]);
      }
    },
    isPC() {
      return !isMobile().any;
    },
  },
});

interface Props {
  novelId: string;
  plotId?: string;
}

interface Data {}

interface Computed {
  plot: Plot | SubPlot;
  isPC: boolean;
}

interface Methods {}
